var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col pb-16", attrs: { "data-id": _vm.panelId } },
    [
      _c(
        "div",
        {
          staticClass: "sticky top-0 z-10 flex flex-col bg-pure-white",
          attrs: { "data-id": _vm.panelId }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-2 px-6 py-6",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex items-center justify-between gap-4",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlTextTitle4", {
                    attrs: {
                      "data-id": _vm.panelId,
                      text: "Reschedule credits"
                    }
                  }),
                  _vm._v(" "),
                  _c("BlIcon", { attrs: { icon: "close", clickable: true } })
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      !_vm.rescheduleCredits.length
        ? _c(
            "div",
            {
              staticClass: "grid px-16 h-128 place-items-center",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("BlTextBody1", {
                staticClass: "text-center",
                attrs: {
                  "data-id": _vm.panelId,
                  text:
                    "All reschedule credits will appear here once you add credits to the client."
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex flex-col px-6",
          attrs: { "data-id": _vm.panelId }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-1 py-3 border-b border-slate-400",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex items-center justify-between gap-2",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlTextBody2", {
                    staticClass: "text-slate-700",
                    attrs: {
                      "data-id": _vm.panelId,
                      text: "Total reschedule credits"
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "text-slate-1000",
                    attrs: {
                      "data-id": _vm.panelId,
                      text: _vm.totalRescheduleCredits + " credit(s)"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.rescheduleCredits, function(credit) {
                return _c(
                  "div",
                  {
                    key: credit.id,
                    staticClass:
                      "flex items-center justify-between gap-2 truncate",
                    attrs: { "data-id": _vm.panelId }
                  },
                  [
                    _c("BlTextBody2", {
                      staticClass: "truncate text-slate-700",
                      attrs: { "data-id": _vm.panelId, text: "ID " + credit.id }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { "data-id": _vm.panelId } },
                      [
                        credit.remaining_reschedule_credit === null
                          ? _c("BlTextBody2", {
                              staticClass: "flex-shrink-0 text-slate-700",
                              attrs: {
                                "data-id": _vm.panelId,
                                text: "∞ credit(s)"
                              }
                            })
                          : _c("BlTextBody2", {
                              staticClass: "flex-shrink-0 text-slate-700",
                              attrs: {
                                "data-id": _vm.panelId,
                                text:
                                  credit.remaining_reschedule_credit +
                                  " credit(s)"
                              }
                            })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2249f575", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2249f575","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/creditTransaction/RescheduleCreditsPanel.vue
// module id = null
// module chunks = 